import type { TSelectedZones } from '../ModalDrawerBulkEdit'

export const keepListedZones = (selectedZones: TSelectedZones[], listedZones: TSelectedZones[]) => {
  const listedIds = new Set(listedZones.map((zone) => zone.id))

  return selectedZones.filter((zone) => listedIds.has(zone.id))
}
